<template lang="pug">
  div(class="vkb_nak_n_slider")
    div(class="vkb_nak_component" :class="{'vkb_nak_n_slider-has-tooltip' :tooltip}")
      div(class="vkb_nak_label_container" v-if="label")
        label(class="vkb_nak_label") {{ label }}
      div(class="vkb_nak_input_container")
        div(class="vkb_nak_input_wrapper")
          div(v-if="!circular" class="vkb_nak_slider" ref="slider")
          circle-slider(v-else :value="value" @input="onInputCircular" :min="min" :max="max" :validValues="validvalues" :readonly="readonly" :prefix="prefix" :suffix="suffix" :theme="theme" :side="side")
</template>

<script>
import noUiSlider from 'nouislider';
import { CircleSlider } from '../../thirdparty/CircleSlider';
import { formatMoney } from '@/modules/utils';
// TODO: implement steps
export default {
  name: 'nSlider',
  components: {
    CircleSlider
  },
  props: {
    readonly: Boolean,
    min: Number,
    max: Number,
    start: Number,
    steps: Object,
    label: { type: String, default: '' },
    prefix: { type: String, default: '' },
    suffix: { type: String, default: '' },
    decimals: { type: Number, default: 0 },
    value: Number,
    side: { type: Number, default: 150 },
    tooltip: Boolean,
    theme: String,
    validvalues: Array,
    circular: { type: Boolean, default: false },
  },
  data() {
    return {
      sliderValue: 0,
    };
  },
  mounted() {
    if (!this.circular) {
      const slider = this.$refs['slider'];
      const options = {
        start: [this.start || 0],
        direction: 'ltr',
        tooltips: [this.tooltip],
        range: {
          min: this.min || 0,
          max: this.max || 100000
        },
        format: {
          to: this.formatTo,
          from: this.formatFrom
        }
      };
      if (this.steps) {
        options.range = this.steps;
      }
      setTimeout(() => {
        noUiSlider.create(slider, options);

        slider.noUiSlider.on('update', range => {
          this.$emit('input', this.formatFrom(range[0]));
        });
      }, 0);
    }
  },
  methods: {
    formatTo(value) {
      return this.prefix + ' ' + formatMoney(parseFloat(value.toFixed(this.decimals))) + ' ' + this.suffix;
    },
    formatFrom(value) {
      return value ? parseFloat(
            value
              .replace(/[.]/g, '')
              .replace(this.prefix, '')
              .replace(this.suffix, '')
              .replace(' ', '')
          ) : 0;
    },
    onInputCircular(value) {
      this.$emit('input', parseInt(value, 10));
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/common/n-slider.vue